import { render, staticRenderFns } from "./ArticleAuthorVerificationModal.vue?vue&type=template&id=79d9c9fd&scoped=true"
import script from "./ArticleAuthorVerificationModal.vue?vue&type=script&lang=js"
export * from "./ArticleAuthorVerificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d9c9fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d9c9fd')) {
      api.createRecord('79d9c9fd', component.options)
    } else {
      api.reload('79d9c9fd', component.options)
    }
    module.hot.accept("./ArticleAuthorVerificationModal.vue?vue&type=template&id=79d9c9fd&scoped=true", function () {
      api.rerender('79d9c9fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/articleAuthorVerification/modules/ArticleAuthorVerificationModal.vue"
export default component.exports